import type { PageTourStep } from "./types";

export function findTourTarget(selector: string): HTMLElement | null {
  return (
    Array.from(document.querySelectorAll<HTMLElement>(selector)).find(
      (node) => {
        const rect = node.getBoundingClientRect();
        const style = getComputedStyle(node);
        return (
          rect.width > 0 && rect.height > 0 && style.visibility !== "hidden"
        );
      }
    ) ?? null
  );
}

export function visibleTourSteps(steps: readonly PageTourStep[]) {
  return steps.filter((step) => findTourTarget(step.target));
}

export function hasOtherDialog() {
  return Array.from(
    document.querySelectorAll<HTMLElement>(
      '.MuiModal-root, [role="dialog"], [role="alertdialog"]'
    )
  ).some((node) => {
    if (node.closest("[data-page-tour-overlay]")) return false;
    const rect = node.getBoundingClientRect();
    return (
      rect.width > 0 &&
      rect.height > 0 &&
      getComputedStyle(node).visibility !== "hidden"
    );
  });
}
